import React from 'react'
import IonIcon from '@reacticons/ionicons'

export default function AIcon(props) {
  return (
    <IonIcon style={{ fontSize: props.size+'px' }} className={`flex items-center justify-center  ${props.className}`} name={props.name} onClick={props.onClick}/>
  )
}
